<template>
  <div>
    <div class="p-2 text-right">
      <el-input 
        v-if="showInput"
        v-model="code" 
        maxlength="20" 
        clearable
        show-word-limit	
        :style="{width: isMobile ? '100%' : '350px'}"
      >
        <template #append>
          <el-button :disabled="!code" @click="handleCreateDiscountCode">
            <i class="fa fa-plus-circle fa-lg mr-2" aria-hidden="true"></i>
            {{ t("promotions.saveCode") }}
          </el-button>
        </template>
      </el-input>
      <el-button v-else type="primary" text @click="showInput = true">
        <i class="fa fa-plus-circle fa-lg mr-2" aria-hidden="true"></i>
        {{ t("promotions.saveCode") }}
      </el-button>
    </div>

    <el-tabs v-model="chooseTab" class="p-2">
      <el-tab-pane :label="t('promotions.now')" name="now">
        <PromotionCodeTab ref="tabRef" :currency="currency" status="now" />
      </el-tab-pane>
      <el-tab-pane :label="t('promotions.past')" name="past">
        <PromotionCodeTab :currency="currency" status="past" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { objCurrency, breakpoint, notificationErrors } from "../../utils"
import { _api_postAccountPromotionCodes } from "../../api/index.js";
import PromotionCodeTab from "./components/PromotionCodeTab.vue"

const props = defineProps({
  store: Object
})
const emit = defineEmits(['update:modelValue'])

const { t, n, locale } = useI18n()

const isMobile = computed(() => breakpoint.value.xs)
const currency = computed(() => {
  if (props.store && props.store?.currency in objCurrency) {
    return objCurrency[props.store.currency].symbol
  }
  return ""
})

const tabRef = ref()
const chooseTab = ref('now')
const code = ref(null)
const showInput = ref(false)

const handleCreateDiscountCode = async () => {
  window.fullPageLoading("show")
  try {
    const params = {
      code: code.value,
      action: "create",
    }
    
    await _api_postAccountPromotionCodes(params)
    toastr.success(t("promotions.saveCodeSuccess"), {
      CloseButton: true,
      ProgressBar: true
    })
    tabRef.value.getData()
    showInput.value = false
  } catch (err) {
    notificationErrors(err.response.data)
    
  } finally {
    code.value = null
    window.fullPageLoading("hide")
  }
}
</script>
